import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Spin } from 'antd';
import '@/Components/Environmental/EnvironmentalCard.less';
import { SensorCard } from '@/Components/SmartHome/SensorCard';
import '@/Components/Environmental/Environmental.less';
import { getOutdoorSensorFormattedData } from '@/Components/Environmental/EnvironmentalUtils';
import SensorChartModal from '@/Components/Sensors/Charts/SensorChartModal';

export const SensorsList = ({
  accessories,
  isLoading,
  useruuid,
  timezone,
  loginUserTimeformat,
  loginUserLocale,
  tempUnit,
  outdoorData,
}) => {
  const [sensors, setSensors] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedSensorDetails, setSelectedSensorDetails] = useState(null);
  const [sensorInfoIcon, setSensorInfoIcon] = useState(null);

  useEffect(() => {
    const sensorDevices = accessories
      .filter((e) => e.productclass === 'smart_home' || e.productclass === 'environmental_sensor')
      .sort((a, b) => {
        return a?.location?.toLowerCase().localeCompare(b?.location?.toLowerCase());
      });

    if (outdoorData) {
      const formattedOutdoorData = getOutdoorSensorFormattedData(outdoorData, tempUnit);
      const outdoorTempHumiditySensor = [
        {
          deviceuuid: 'outdoor_temperature_humidity_sensor',
          location: 'Outdoor',
          modelname: 'Current Conditions',
          productclass: 'environmental_sensor',
          devicetype: 'outdoor_temperature_humidity_sensor',
          ...formattedOutdoorData,
        },
      ];
      setSensors([...sensorDevices, ...outdoorTempHumiditySensor]);
    } else {
      setSensors(sensorDevices);
    }
  }, [accessories, outdoorData]);

  if (isLoading)
    return (
      <Row style={{ justifyContent: 'center' }}>
        <Spin spinning={true}></Spin>
      </Row>
    );
  if (!sensors.length) return <div style={{ marginTop: 16 }}>No devices found</div>;

  const handleOnClose = (e) => {
    e.stopPropagation();
    setShowModal(false);
  };

  return (
    <Row style={{ marginBottom: 10 }}>
      <Col span={24}>
        <div className="cards-container">
          {sensors.map((sensor) => (
            <SensorCard
              key={sensor.deviceuuid}
              sensor={sensor}
              useruuid={useruuid}
              timezone={timezone}
              loginUserTimeformat={loginUserTimeformat}
              loginUserLocale={loginUserLocale}
              tempUnit={tempUnit}
              outdoorData={outdoorData}
              setShowModal={setShowModal}
              setSelectedSensorDetails={setSelectedSensorDetails}
              setSensorInfoIcon={setSensorInfoIcon}
            />
          ))}
        </div>
      </Col>
      <SensorChartModal
        open={showModal}
        sensorDetails={selectedSensorDetails}
        sensorInfoIcon={sensorInfoIcon}
        onClose={handleOnClose}
        useruuid={useruuid}
        timezone={timezone}
        timeFormat={loginUserTimeformat}
        loginUserLocale={loginUserLocale}
        deviceType={selectedSensorDetails?.devicetype}
        setSelectedSensorDetails={setSelectedSensorDetails}
        userTempUnit={tempUnit}
      />
    </Row>
  );
};

SensorsList.propTypes = {
  accessories: PropTypes.array,
  isLoading: PropTypes.bool,
  useruuid: PropTypes.string,
  timezone: PropTypes.string,
  loginUserTimeformat: PropTypes.shape({ is24hoursformat: PropTypes.bool }),
  loginUserLocale: PropTypes.string,
  tempUnit: PropTypes.string,
  outdoorData: PropTypes.object,
};
